/**
 * Enum trạng thái websocket trả về
 * nnduc 24/4/2024
 */
export default {
    Success: 1,
    Error: 2
};
